export const isUrlLocalhost = (urlString: string) => {
  try {
    const url = new URL(urlString);
    return url.hostname === 'localhost';
  } catch {
    return false;
  }
};
